// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'notionLight',
    themes: {
      notionLight: {
        dark: false,
        colors: {
          primary: '#326348',
          secondary: '#6b7280',
          background: '#f7f8f2',
          surface: '#ffffff',
          info: '#2f6feb',
          success: '#16a34a',
          warning: '#d97706',
          error: '#dc2626',
        },
      },
    },
  },
})
